import type { NavigateFunction } from 'react-router-dom';
import type { QueryClient } from '@tanstack/react-query';
import type { SessionResponse } from '@/api/auth.api';
import type { SignInRequired } from '@/lib/types/auth.types';
import { isSignInRequired } from '@/lib/utils/sign-in-required.utils';
import { setAccessToken } from './session';
import { ROUTES } from '@/lib/constants/routes';

/**
 * Land an invitee whose email is now verified, however they got there: through
 * the emailed code (`verify-otp`, the resume branch) or straight from accepting
 * the invitation (FR-208). With 2FA on there is no session yet, so the success
 * screen sends the user to sign in, which leads to authenticator setup
 * (MYN-241); otherwise the session is stored and the auth cache seeded.
 */
export function completeVerifiedOutcome(
  outcome: SessionResponse | SignInRequired,
  opts: { queryClient: QueryClient; navigate: NavigateFunction },
): void {
  if (isSignInRequired(outcome)) {
    opts.navigate(ROUTES.AUTH.EMAIL_VERIFIED, { state: { signInRequired: true } });
    return;
  }
  setAccessToken(outcome.accessToken);
  opts.queryClient.setQueryData(['auth', 'me'], outcome.user);
  opts.navigate(ROUTES.AUTH.EMAIL_VERIFIED);
}
